import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then((r) => {
        setUser(r.data);
        navigate("/account", { replace: true });
      })
      .catch(() => {
        setUser(false);
        navigate("/account", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex h-screen items-center justify-center" data-testid="auth-callback-loading">
      <p className="font-mono text-xs tracking-[0.35em] text-fade">ALIGNING…</p>
    </div>
  );
}
